import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import AuthTokenHolder from "@/services/http/AuthTokenHolder";
import { get, post } from "@/services/http/platformServer";

interface SecTokenParams {
    appKey: string;
    time: string;
    userId: string;
    taobaoUserId: string;
    topAppKey: string;
    appName: string;
    userIp: string;
    ati: string;
    sign: string;
    sessionId: string;
}

export function getSecTokenParams(shopId: number) {
    const token = AuthTokenHolder.getToken();

    return get<SecTokenParams>(shopId, "/taobao/order/security/sec_token_params", {
        shopId,
        token,
    });
}

interface TopTokenParams {
    appKey: string;
    time: string;
    userId: string;
    taobaoUserId: string;
    topAppKey: string;
    appName: string;
    userIp: string;
    ati: string;
    sign: string;
    sessionId: string;
    method: string;
    secToken: string;
    topToken: string;
}

export function getTopDataParams(shopId: number, method: string, secToken: string) {
    const token = AuthTokenHolder.getToken();

    return get<TopTokenParams>(shopId, "/taobao/order/security/top_data_params", {
        shopId,
        token,
        method,
        secToken,
    });
}

interface TbPrivacyProtectionSecretExtendParams {
    shopId: number;
    orderId: number;
    originalId: string;
    mergeSplitStatus: OrderMergeSplitStatus;
}

interface TbPrivacyProtectionSecretExtendData {
    expireTime: string;
    secretNo: string;
}

/**
 * 淘宝隐私号时间延长
 */
export function tbPrivacyProtectionSecretExtend(params: TbPrivacyProtectionSecretExtendParams) {
    return post<TbPrivacyProtectionSecretExtendData>(params.shopId, "/taobao/secret_extend", params);
}
